import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
:root {
  --font-family: "Manrope", sans-serif;
  --secondary-font-family: "Courier New", monospace;
  --primary-color: #cbd136;
  --white-color: #fff;
  --dark-color: #1E1E1E;
}

body {
  font-family: var(--secondary-font-family);
  font-size: 20px;
  color: #323330;
  background-color: var(--white-color);
}

h1,
h2 {
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
  line-height: 1;
}

h1 {
  font-size: 67px;
}
h2 {
  font-size: 47px;
}

p {
  text-align: center;
  line-height: 1.5;
}

a,
a:hover,
a:focus {
  color: var(--primary-color);
  text-decoration-line: none;
}

ul {
  list-style-type: none;
}

img {
  max-width: 100%;
  height: auto;
}

.mb-20 {
  margin-bottom: 20px;
}

.wrapper {
  max-width: 96%;
  margin: 0 auto;
}

/* BUTTON */
button,
.button,
input[type="button"],
input[type="submit"] {
  background: var(--primary-color);
  border: none;
  padding: 15px 20px;
  border-radius: 8px;
  color: var(--white-color);
  font-family: var(--font-family);
  font-size: 20px;
  cursor: pointer;
  display: inline-block;
  /* margin-top: 35px; */
}
.hover {
  transition: all 500ms ease;
}
.hover:before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 0px;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  transition: all 800ms ease;
}
.hover:hover:before {
  width: 100%;
}

  @media screen and (max-width: 722px) {
    h1 {
      font-size: 48px;
    }

    .wrapper {
      width: 95%;
    }
  }
`;

export default GlobalStyle; 